const sumNumbers = (values: number[]) => {
    return values.reduce((agg, value) => {
        agg += value;
        return agg;
    }, 0);
};

function sum<T extends Record<string, unknown>>(
    items: T[],
    iteratee: (item: T) => number | number[]
): number;
function sum(items: number[]): number;
function sum<T>(
    items: T[],
    iteratee?: T extends number ? never : (item: T) => number | number[]
): number {
    const hasIteratee = !!iteratee;
    if (!hasIteratee && !items.every(item => typeof item === "number"))
        throw new Error("can only sum array of numbers");

    const numbersToSum = hasIteratee
        ? items.flatMap(item => {
              const value = iteratee?.(item);
              if (typeof value === "number") {
                  return value;
              }
              if (Array.isArray(value)) {
                  return value.flatMap(value =>
                      typeof value === "number" ? value : 0
                  );
              }
              throw new Error(
                  "cannot sum something that is not a number; " +
                      JSON.stringify(item)
              );
          })
        : (items as unknown as number[]);

    return sumNumbers(numbersToSum);
}

export { sum };
